<template lang="pug">
  section.faq-section(v-if="faqs.length > 0")
    accordion-group
      accordion(v-for="faq in faqs" :key="faq.id" :heading="faq.question")
        div(v-html="bodyText(faq.answer)")
</template>

<script>
  import Accordion from 'scripts/components/basic/Accordion.vue';
  import AccordionGroup from 'scripts/components/basic/AccordionGroup.vue';

  export default {
    name: 'FaqSection',
    components: { Accordion, AccordionGroup },
    props: {
      faqs: Array,
    },
    methods: {
      bodyText(text) {
        return String(text)
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"');
      },
    },
  };
</script>

<style lang="scss">
  .faq-section {
    margin: 0 auto;
    max-width: 1440px;
    font-family: $font-secondary;
  }
</style>
